<template>
  <transition name="drawer">
    <div v-if="isOpen" class="drawer-overlay" @click.self="$emit('close')">
      <div class="drawer-content">
        <div class="drawer-header">
          <h3 class="drawer-title">
            <feather-icon icon="FilterIcon" size="18" />
            Filtros Avançados
          </h3>
          <button class="drawer-close" @click="$emit('close')">
            <feather-icon icon="XIcon" size="20" />
          </button>
        </div>

        <div class="drawer-body">
          <div class="filter-group">
            <label class="filter-label">Pré Pedido</label>
            <input
              type="number"
              class="filter-input"
              placeholder="Número do pré pedido"
              v-model="localFilters.prePedido"
            />
          </div>

          <div class="filter-group">
            <label class="filter-label">Pedido ERP</label>
            <input
              type="text"
              class="filter-input"
              placeholder="Número do pedido ERP"
              v-model="localFilters.pedidoErp"
            />
          </div>

          <div class="filter-group">
            <label class="filter-label">Cliente (ID)</label>
            <input
              type="number"
              class="filter-input"
              placeholder="ID do cliente"
              v-model="localFilters.cliente"
            />
          </div>

          <div class="filter-group">
            <label class="filter-label">Razão Social</label>
            <input
              type="text"
              class="filter-input"
              placeholder="Nome ou razão social"
              v-model="localFilters.razaoSocial"
            />
          </div>

          <div class="filter-row">
            <div class="filter-group">
              <label class="filter-label">Data Inicial</label>
              <input
                type="date"
                class="filter-input"
                v-model="localFilters.dataInicial"
              />
            </div>

            <div class="filter-group">
              <label class="filter-label">Data Final</label>
              <input
                type="date"
                class="filter-input"
                v-model="localFilters.dataFinal"
              />
            </div>
          </div>
        </div>

        <div class="drawer-footer">
          <button class="btn-secondary" @click="clearFilters">
            <feather-icon icon="RefreshCwIcon" size="16" />
            Limpar
          </button>
          <button class="btn-primary" @click="applyFilters">
            <feather-icon icon="SearchIcon" size="16" />
            Aplicar Filtros
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'FiltersDrawer',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      localFilters: {
        prePedido: null,
        pedidoErp: null,
        cliente: null,
        razaoSocial: '',
        dataInicial: '',
        dataFinal: '',
        status: null,
      },
    };
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.localFilters = {
          prePedido: null,
          pedidoErp: null,
          cliente: null,
          razaoSocial: '',
          dataInicial: '',
          dataFinal: '',
          status: null,
          ...this.filters,
        };
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
  },
  methods: {
    applyFilters() {
      this.$emit('apply', { ...this.localFilters });
      this.$emit('close');
    },
    clearFilters() {
      this.localFilters = {
        prePedido: null,
        pedidoErp: null,
        cliente: null,
        razaoSocial: '',
        dataInicial: '',
        dataFinal: '',
        status: null,
      };
      this.$emit('apply', { ...this.localFilters });
      this.$emit('close');
    },
  },
  beforeDestroy() {
    document.body.style.overflow = '';
  },
};
</script>

<style scoped>
.drawer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
}

.drawer-content {
  width: 100%;
  max-width: 420px;
  height: 100%;
  background: var(--card-bg, #ffffff);
  display: flex;
  flex-direction: column;
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.15);
}

.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--border-color, #e5e7eb);
}

.drawer-title {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  font-size: 1.0625rem;
  font-weight: 600;
  color: var(--text-primary, #1e293b);
  margin: 0;
}

.drawer-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: transparent;
  border: none;
  color: var(--text-muted, #94a3b8);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.drawer-close:hover {
  background: var(--hover-bg, #f1f5f9);
  color: var(--text-secondary, #64748b);
}

.drawer-body {
  flex: 1;
  padding: 1.25rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.filter-label {
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--text-secondary, #64748b);
}

.filter-input {
  height: 42px;
  padding: 0 0.875rem;
  font-size: 0.875rem;
  color: var(--text-primary, #1e293b);
  background: var(--input-bg, #ffffff);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 8px;
  transition: all 0.15s ease;
  outline: none;
}

.filter-input:focus {
  border-color: var(--primary, #7c3aed);
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
}

.filter-input::placeholder {
  color: var(--text-muted, #94a3b8);
}

select.filter-input {
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  padding-right: 2.5rem;
}

.filter-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

.drawer-footer {
  display: flex;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-top: 1px solid var(--border-color, #e5e7eb);
}

.btn-primary,
.btn-secondary {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.btn-primary {
  background: var(--primary, #7c3aed);
  color: #ffffff;
  border: none;
}

.btn-primary:hover {
  background: var(--primary-dark, #6d28d9);
}

.btn-secondary {
  background: transparent;
  color: var(--text-secondary, #64748b);
  border: 1px solid var(--border-color, #e5e7eb);
}

.btn-secondary:hover {
  background: var(--hover-bg, #f1f5f9);
}

.drawer-enter-active,
.drawer-leave-active {
  transition: opacity 0.2s ease;
}

.drawer-enter-active .drawer-content,
.drawer-leave-active .drawer-content {
  transition: transform 0.3s ease;
}

.drawer-enter,
.drawer-leave-to {
  opacity: 0;
}

.drawer-enter .drawer-content,
.drawer-leave-to .drawer-content {
  transform: translateX(100%);
}

body.dark-layout .drawer-content {
  background: var(--dark-card-bg, #283046);
}

body.dark-layout .drawer-header,
body.dark-layout .drawer-footer {
  border-color: var(--dark-border, #3b4253);
}

body.dark-layout .drawer-title {
  color: var(--dark-text-primary, #d0d2d6);
}

body.dark-layout .filter-label {
  color: var(--dark-text-secondary, #b4b7bd);
}

body.dark-layout .filter-input {
  background: var(--dark-input-bg, #242b3d);
  border-color: var(--dark-border, #3b4253);
  color: var(--dark-text-primary, #d0d2d6);
}
</style>
